import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.997.997 0 0 0 .883-1.467L12.884 2.532ZM13 18h-2v-2h2v2Zm-2-4V9h2l.001 5H11Z"
	})
});
export default SvgBxError;
